import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { Input } from "@nova/ds-component-input"
import { ButtonDestructive, ButtonTertiary } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { FunctionComponent, useState } from "react"
import { useDeleteAircraft } from "./AircraftQueries"

interface DeleteAircraftModalProps {
    aircraftId: string
    nickname: string
    onSubmit: () => void
    onCancel: () => void
}

const DeleteAircraftModal: FunctionComponent<DeleteAircraftModalProps> = ({
    aircraftId,
    nickname,
    onCancel,
    onSubmit,
}) => {
    const { deleteAircraft, isDeleting } = useDeleteAircraft()
    const [confirmationInput, setConfirmationInput] = useState("")

    const canDelete = confirmationInput === nickname && !isDeleting

    const handleDelete = async () => {
        await deleteAircraft(aircraftId)
        onSubmit()
    }

    return (
        <HighPriorityNovaModalContainer
            className="max-w-lg w-full"
            title={`Delete ${nickname}?`}
            closeModal={onCancel}
            bottomBar={
                <div className="flex justify-end gap-2 w-full">
                    <ButtonTertiary title="Cancel" onClick={onCancel} />
                    <ButtonDestructive
                        title="Delete Drone"
                        LeftIcon={Icons.Trash}
                        onClick={handleDelete}
                        disabled={!canDelete}
                    />
                </div>
            }
        >
            <div className="flex flex-col gap-4 pt-2 items-center">
                <h4 className="text-gray-0">
                    This will disconnect every flight that references this drone.
                </h4>
                <h4 className="text-red-500">This cannot be undone.</h4>
                <Input
                    value={confirmationInput}
                    onChange={(e) => setConfirmationInput(e.currentTarget.value)}
                />
                <h5 className="text-gray-300 text-center">
                    Type the name &ldquo;{nickname}&rdquo; to delete this drone.
                </h5>
            </div>
        </HighPriorityNovaModalContainer>
    )
}

export { DeleteAircraftModal }
